var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReturn1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 4.5H8.25C9.4905 4.5 10.5 5.5095 10.5 6.75C10.5 7.9905 9.4905 9 8.25 9H6V10.5H8.25C10.3177 10.5 12 8.81775 12 6.75C12 4.68225 10.3177 3 8.25 3H3.75V0.75L0 3.75L3.75 6.75V4.5Z",
    fill: "#637381"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturn1);
export default __webpack_public_path__ + "static/media/return1.adb2bc16f70ac515b8edb6b3706c9771.svg";
export { ForwardRef as ReactComponent };